import React, { useEffect, useState, useContext } from "react"
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Grid, IconButton } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import { Drawer, TextField, Box, Container } from "@mui/material";
import PhoneInput from 'react-phone-input-2'
import { IMAGES_URL } from "Utils/URLs";
import { getDisplayUrl } from "Utils/mediaUrl";
import EditIcon from '@mui/icons-material/Edit';
import AuthState from "../Hooks/Authinctication.state";
import RenderStatus from "./RenderStatus";
import NotificationState from "Hooks/Notification.state";
import { UserContext } from "Hooks/UserContext";
import { Close, ChevronLeft, ArrowBackIos } from "@mui/icons-material";
import PaymentComponent from "./PaymentComponent/PaymentComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

// STYLES
const styles = {
    details: {
        padding: "1rem",
        borderTop: "1px solid #e1e1e1",
        
    },
    value: {
        padding: "1rem 2rem",
        borderTop: "1px solid #e1e1e1",
        color: "#899499"
    }
};

//APP
export default function ProfileCard({ setValue }) {
    const { UpdateProfile, response, formBusy, GetUserProfile } = AuthState()
    const [openDrawer, setOpenDrawer] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate()

    const { notificationRes, user } = useContext(UserContext)
    const formatDate = (d) => {
        if (!d) return "";
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return "";
        return dt.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
    };
    const [data, setData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        apt: "",
        state: "",
        zip_code: "",
        imageUrl: ""
    })

    useEffect(() => {
        GetUserProfile()

        setOpenDrawer(false)
    }, [response, notificationRes])

    const handleImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0]
            setData((prev) => ({ ...prev, imageUrl: URL.createObjectURL(file) }))
            setSelectedImage(event.target.files[0]);
        }
    };


    const hanldeOpenDrawer = () => {
        setOpenDrawer(true)
        setData({
            first_name: user?.first_name,
            last_name: user?.last_name,
            email: user?.email,
            phone: user?.phone,
            address: user?.address,
            city: user?.city,
            apt: user?.apt,
            state: user?.state,
            zip_code: user?.zip_code
        })
    }

    const hanldeUpdateProfile = () => {
        const formData = new FormData()
        formData.append("first_name", data.first_name)
        formData.append("last_name", data.last_name)
        formData.append("email", data.email)
        formData.append("phone", data.phone)
        formData.append("address", data.address)
        formData.append("city", data.city)
        formData.append("apt", data.apt)
        formData.append("state", data.state)
        formData.append("zip_code", data.zip_code)
        formData.append("profile_pic", selectedImage)
        UpdateProfile(formData)
    }

    return (
        <Card  variant="elevation" elevation={5}>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}} className="d-flex d-md-none" >
            <IconButton onClick={() => setValue(0)} sx={{ backgroundColor: "#92c323", m: 2, px: 3, color: "#FFF", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                <FontAwesomeIcon icon={faChevronLeft} />
            </IconButton>
                <Box sx={{ justifyContent: "end" }} className="mx-2 " >
                    <Button onClick={() => navigate("/driver_forms/profile/edit")} startIcon={<i className="ri-edit-box-line align-bottom" />} variant="contained" sx={{ px: 2, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} >Edit Profile</Button>
                </Box>
            </Box>
            
            <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)} anchor="right"  >
                <Box sx={{ width: { xs: "100%", md: 700 } }} className="profile-update" >
                    <Container>
                        <IconButton onClick={() => setOpenDrawer(false)} >
                            <Close />
                        </IconButton>
                        <Typography variant="h5" textAlign={"center"} >Profile</Typography>
                        <Box sx={{ display: "flex", justifyContent: "center" }} >
                            <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}

                                badgeContent={
                                    <IconButton onClick={() => document.getElementById('icon-button-file').click()} >
                                        <EditIcon
                                            sx={{
                                                border: "5px solid white",
                                                backgroundColor: "#92c323",
                                                borderRadius: "50%",
                                                padding: ".2rem",
                                                width: 35,
                                                height: 35
                                            }}
                                        ></EditIcon>
                                    </IconButton>
                                }
                            >
                                <Avatar
                                    sx={{ width: 100, height: 100, mb: 1.5 }}
                                    src={data.imageUrl !== "" ? data.imageUrl : user?.profile_pic ? getDisplayUrl(user.profile_pic, IMAGES_URL) : "https://media.glamour.com/photos/5a425fd3b6bcee68da9f86f8/master/pass/best-face-oil.png"}
                                ></Avatar>
                            </Badge>
                            <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id="icon-button-file"
                                type="file"
                                onChange={handleImageChange}
                            />
                        </Box>
                        <Grid container pt={4}   >
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >First name</label>
                                <TextField value={data.first_name} onChange={(e) => setData((prev) => ({ ...prev, first_name: e.target.value }))} fullWidth />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Last name</label>
                                <TextField value={data.last_name} onChange={(e) => setData((prev) => ({ ...prev, last_name: e.target.value }))} fullWidth />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Email</label>
                                <TextField fullWidth value={data.email} onChange={(e) => setData((prev) => ({ ...prev, email: e.target.value }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Phone</label>
                                <PhoneInput disableCountryCode onlyCountries={["us"]} country={"us"} placeholder='Enter your 10 digit phone number' value={data.phone} onChange={(e) => setData((prev) => ({ ...prev, phone: e }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Address</label>
                                <TextField fullWidth value={data.address} onChange={(e) => setData((prev) => ({ ...prev, address: e.target.value }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >City</label>
                                <TextField fullWidth value={data.city} onChange={(e) => setData((prev) => ({ ...prev, city: e.target.value }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Apt, Suit, Unit, etc</label>
                                <TextField fullWidth value={data.apt} onChange={(e) => setData((prev) => ({ ...prev, apt: e.target.value }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >State</label>
                                <TextField fullWidth value={data.state} onChange={(e) => setData((prev) => ({ ...prev, state: e.target.value }))} />
                            </Grid>
                            <Grid xs={12} md={6} px={2} pt={3} >
                                <label style={{ color: "#000" }} >Zip Code</label>
                                <TextField fullWidth value={data.zip_code} onChange={(e) => setData((prev) => ({ ...prev, zip_code: e.target.value }))} />
                            </Grid>
                        </Grid>
                        <Box px={2} pt={3} >
                            <Button fullWidth sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} size="large" variant="contained" color="secondary" onClick={hanldeUpdateProfile} >
                                {formBusy ? "Please wait..." : "Update"}
                            </Button>
                        </Box>
                    </Container>
                </Box>
            </Drawer>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}} className="d-none d-md-flex" >
            <Typography textAlign={"start"} p={2} fontWeight={600} color="text.secondary">Profile Information</Typography>
          
                <Box sx={{ justifyContent: "end" }} className="mx-2 " >
                    <Button onClick={() => navigate("/driver_forms/profile/edit")} startIcon={<i className="ri-edit-box-line align-bottom" />} variant="contained" sx={{ px: 2, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} >Edit Profile</Button>
                </Box>
            </Box>
            <Grid
                container
                direction="column"

            >
                {/* CARD HEADER START */}
                <Grid item sx={{ p: "1.5rem 0rem", textAlign: "center" }}>
                    {/* PROFILE PHOTO */}
                    {/* <Box sx={{ display: "flex", justifyContent: "center" }} >
                        <Avatar
                            sx={{ width: 100, height: 100, mb: 1.5 }}
                            src={user?.profile_pic ? getDisplayUrl(user.profile_pic, IMAGES_URL) : ""}
                        ></Avatar>
                    </Box> */}

                    {/* DESCRIPTION */}
                    {/* <Typography variant="h6">{user?.first_name} {user?.last_name}</Typography>
                    <Typography color="text.secondary">{user?.email}</Typography> */}
                </Grid>
                {/* CARD HEADER END */}

                {/* DETAILS */}

                <Grid container>
                    <Grid item xs={12}>

                        {
                            user?.uuid && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} fontWeight={600} style={styles.details} textTransform={"capitalize"} >User ID</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.uuid}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.email && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={3} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} fontWeight={600} style={styles.details} textTransform={"capitalize"} >Email</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={9} textAlign={"end"} whiteSpace={"collapse"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.email}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.phone && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} fontWeight={600} style={styles.details} textTransform={"capitalize"} >Phone</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.phone}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.street_name && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6}  >
                                            <Typography fontSize={{ xs: 12, md: 15 }} fontWeight={600} style={styles.details} textTransform={"capitalize"} >Street Name</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.street_name}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.address && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"} >Address</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.address}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.city && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"} >City</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.city}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.apt && (
                                <>
                                    <Grid container >
                                        <Grid item xs={6} md={6}  >
                                            <Typography fontSize={{ xs: 12, md: 15 }} fontWeight={600} style={styles.details} textTransform={"capitalize"} >Apt, Suit, Unit, etc</Typography>
                                        </Grid>
                                        <Grid item xs={6} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.apt}</Typography>
                                        </Grid>
                                    </Grid>
                                </>

                            )
                        }
                        {
                            user?.state && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"} >State</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.state}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            user?.zip_code && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6}  >
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"} >Zip Code</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.zip_code}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }

                        {
                            user?.status && (
                                <>
                                    <Grid container >
                                        <Grid item xs={4} md={6} >
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"} >Status</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"} >
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{RenderStatus(user.status)}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }

                        {
                            user?.company && (
                                <>
                                    <Grid container>
                                        <Grid item xs={4} md={6}>
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"}>Company</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"}>
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{user?.company}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }

                        {
                            user?.created_at && (
                                <>
                                    <Grid container>
                                        <Grid item xs={4} md={6}>
                                            <Typography fontWeight={600} fontSize={{ xs: 12, md: 15 }} style={styles.details} textTransform={"capitalize"}>Started from</Typography>
                                        </Grid>
                                        <Grid item xs={8} md={6} textAlign={"end"}>
                                            <Typography fontSize={{ xs: 12, md: 15 }} style={styles.value}>{formatDate(user.created_at)}</Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }



                    </Grid>


                </Grid>

                {/* BUTTON */}
                {/* <Grid item style={styles.details} textTransform={"capitalize"}  sx={{ width: "100%" }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        
                        onClick={hanldeOpenDrawer}
                        sx={{width: "99%", p: 1, my: 2,backgroundColor:"#92c323",'&:hover':{backgroundColor:"#76a521"}}}
                    >
                    
                        Update Profile
                    </Button>
                </Grid>
                */}
            </Grid>
        </Card>
    );
}
